/* Tea PDP: gallery, format (variant) switching, origin map. Timer + qty + AJAX cart come from editorial.js. */
(function () {
  'use strict';
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  $$('[data-tea-pdp]').forEach(function (root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    /* Gallery */
    var slides = $$('[data-tea-slide]', root), thumbs = $$('[data-tea-thumb]', root), count = root.querySelector('[data-tea-count]');
    function show(n) {
      n = String(n);
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-tea-slide') === n); });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-tea-thumb') === n;
        t.setAttribute('aria-current', String(on));
        if (on && t.parentElement.scrollWidth > t.parentElement.clientWidth) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      });
      if (count) count.textContent = n;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-tea-thumb')); }); });

    /* Format = variant cards */
    var input = root.querySelector('[data-tea-variant]'), price = root.querySelector('[data-tea-price]'), atc = root.querySelector('[data-tea-atc]');
    var amount = root.querySelector('[data-tea-amount]'), fact = root.querySelector('[data-tea-fact]');
    $$('[data-tea-format]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-tea-format]', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        if (input) input.value = b.getAttribute('data-variant-id');
        if (price) {
          price.textContent = b.getAttribute('data-price');
          var c = b.getAttribute('data-compare');
          if (c) { var s = document.createElement('s'); s.textContent = c; price.appendChild(document.createTextNode(' ')); price.appendChild(s); }
        }
        var ok = b.getAttribute('data-available') === 'true';
        if (atc) { atc.disabled = !ok; atc.textContent = ok ? 'Add to cart' : 'Sold out'; }
        var am = b.getAttribute('data-amount');
        if (amount && am) amount.textContent = am;
        if (fact) fact.textContent = am === '1 bag' ? 'Tea bags' : 'Loose leaf';
        var mid = b.getAttribute('data-media');
        if (mid) { var sl = root.querySelector('[data-media-id="' + mid + '"]'); if (sl) show(sl.getAttribute('data-tea-slide')); }
        if (window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', b.getAttribute('data-variant-id')); window.history.replaceState({}, '', u.toString()); }
      });
    });

    /* Origin map */
    var map = root.querySelector('[data-tea-map]');
    if (map) {
      var draw = function () {
        if (!window.d3 || !window.topojson) return false;
        var lat = parseFloat(map.getAttribute('data-lat')), lng = parseFloat(map.getAttribute('data-lng'));
        var W = 600, H = 440;
        var proj = d3.geoMercator().center([lng, lat]).scale(900).translate([W / 2, H / 2]);
        var svg = d3.select(map).insert('svg', ':first-child').attr('viewBox', '0 0 ' + W + ' ' + H).attr('preserveAspectRatio', 'xMidYMid slice').attr('aria-hidden', 'true');
        var path = d3.geoPath(proj);
        svg.append('path').attr('class', 'tea-pdp__graticule').attr('d', path(d3.geoGraticule().step([5, 5])()));
        var land = svg.append('g');
        var pt = proj([lng, lat]);
        var g = svg.append('g').attr('transform', 'translate(' + pt[0] + ',' + pt[1] + ')');
        g.append('circle').attr('r', 22).attr('class', 'tea-pdp__pulse');
        g.append('circle').attr('r', 7).attr('class', 'tea-pdp__dot');
        fetch('https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-50m.json').then(function (r) { return r.json(); }).then(function (topo) {
          land.selectAll('path').data(topojson.feature(topo, topo.objects.countries).features).join('path').attr('class', function (f) { return 'tea-pdp__land' + (f.id === '356' ? ' tea-pdp__land--india' : ''); }).attr('data-iso', function (f) { return f.id; }).attr('d', path);
          var indiaUrl = map.getAttribute('data-india-url') || window.LUXMI_INDIA_URL;
          if (!indiaUrl) return;
          return fetch(indiaUrl).then(function (r) { if (!r.ok) throw new Error('no india'); return r.json(); }).then(function (india) {
            var geom = india.geometry || (india.features && india.features[0] && india.features[0].geometry) || india;
            (geom.type === 'Polygon' ? [geom.coordinates] : geom.coordinates).forEach(function (poly) {
              if (d3.geoArea({ type: 'Polygon', coordinates: poly }) > 2 * Math.PI) poly.forEach(function (ring) { ring.reverse(); });
            });
            land.select('[data-iso="356"]').remove();
            land.append('path').attr('class', 'tea-pdp__land').attr('d', path(geom));
          });
        }).catch(function () {});
        return true;
      };
      if (!draw()) window.addEventListener('load', draw, { once: true });
    }
  });
})();
